import Vue from "vue";
//noinspection TypeScriptCheckImport
import Settings from "./Settings.vue";
import 'setimmediate';

Vue.config.devtools = true;

const app = new Vue({
    el: "#oc-settings",
    template: `
    <settings/>
    `,
    components: {
        Settings,
    }
});



// WEBPACK FOOTER //
// ./src/webpack/vue/settings/index.ts